import { mapGetters } from "vuex";
import { RTM_MESSAGE_TYPE } from "@/configs/RTM_SDK";
import {STATUS_MESSAGES, SYSTEM_MESSAGES} from "@/messages/System";
import HelperMixins from "@/mixins/HelperMixins";
import {SDK_API} from "@/configs/APIs";
import {STATUS_RESPONSES} from "@/configs/SDK";
import {REGEXS} from "@/configs/Settings";

const JP_SPACE_CODE = 12288;

export default {
   name: "Message Channel Mixins",
   mixins: [ HelperMixins ],
   data() {
      return {
         listNaughtyWords: ["shit", "idiot", "stupid", "noob", "fuck", "bitch", "huhu", "mememe", "FuK", "他妈的", "草泥马", "ตอบ", " お客"]
      };
   },
   computed: {
      ...mapGetters({
         user: "user"
      })
   },
   created() {},
   mounted() {
      this.getListNaughtyWords();
   },
   methods: {
       /**
        *
        * @param newMessage
        * @param type
        * @param data
        * @returns {null|{GuestId, DisplayName, Data, Timestamp: *, MessageType}|boolean}
        */
      formatMessageChannelBeforeSend: function(newMessage, type = RTM_MESSAGE_TYPE.MESSAGE, data = null) {
         if (!this.user) return false;

         let messageChannel = {
            // data for mobile app
            MessageType: type,
            GuestId: this.user.guestId,
            UserId: this.user.userInfo?.userId,
            DisplayName: this.user.displayName,
            Data: data,
            Timestamp: Math.round(Date.now()/1000)
         };

         // Additional data for each type message
         switch (type) {
            case RTM_MESSAGE_TYPE.MESSAGE: {
               // Check naughty:
               let isNaughty = false;
               newMessage = newMessage.trim();
               const jpSpace = String.fromCharCode(JP_SPACE_CODE);
               let checkProfanityMessage = this.replaceAll(newMessage, jpSpace, " ");
               let arrayWords = checkProfanityMessage.trim().split(" ");
               arrayWords.map((messageWord) => {
                  this.listNaughtyWords.map((naughtyWord) => {
                     if (naughtyWord.trim().toLowerCase() === messageWord.trim().toLowerCase()) {
                        isNaughty = true;
                        newMessage = this.replaceAll(newMessage, messageWord, "");
                     }
                  });
               });

               if (isNaughty) {
                  this.$root.$emit("showToast", SYSTEM_MESSAGES.BANNED_WORD);
                  this.$root.$emit("warning-user-naughty-word");
                  return null;
               } 
               else if (new RegExp(REGEXS.VIEW_URL).test(newMessage)) { // check URLs:
                  this.$root.$emit("showToast", SYSTEM_MESSAGES.BANNED_WORD);
                  this.$root.$emit("warning-user-naughty-word");
                  return null;
               } 
               else {
                  messageChannel = Object.assign(messageChannel, {
                     Message: newMessage
                  });
               }
               break;
            }

            case RTM_MESSAGE_TYPE.LIKE:
               messageChannel = Object.assign(messageChannel, newMessage);
               break;

            case RTM_MESSAGE_TYPE.STATISTIC:
               messageChannel = Object.assign(messageChannel, newMessage);
               break;

            case RTM_MESSAGE_TYPE.END: {
               messageChannel = Object.assign(messageChannel, newMessage);
               break;
            }
            case RTM_MESSAGE_TYPE.ADMIN_DELETE_MESSAGE: {
               messageChannel = Object.assign(messageChannel, newMessage);
               break;
            }
         }
         return messageChannel;
      },

      /**
       * 
       * @param {*} str 
       * @param {*} search 
       * @param {*} replace 
       */
      replaceAll(str, search, replace) {
         return str.split(search).join(replace);
      },

      /**
       * Get list naughty words
       *
       */
      getListNaughtyWords: function() {
         let _this = this;
         this.$http
             .post(SDK_API.NAUGHTY_WORDS)
             .then(response => {
                 if (response.data.code === STATUS_RESPONSES.SUCCESS) {
                     _this.listNaughtyWords = response.data.data;
                 }
             })
             .catch(function (error) {
                 console.log(error);
                 _this.$toastr.e(SYSTEM_MESSAGES.CONTACT_ADMIN, STATUS_MESSAGES.ERROR);
             })
             .then(() => {
             });
      },
   }
};
